var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSize15(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 83,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DFE0E5",
    d: "M.362.176h97.862v82.245H.362z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.649 34.532h84.328v14.575H7.649z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECECF0",
    d: "M9.731 37.655h24.986v8.329H9.731zm28.11 0h39.561v3.123H37.841zm0 5.205h39.561v3.123H37.841z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#223143",
    d: "M80.525 37.655h8.329v8.329h-8.329z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSize15);
export default __webpack_public_path__ + "static/media/size-15.fd3d26d46c7198a58fe80cd026b988fc.svg";
export { ForwardRef as ReactComponent };